'use client';

import { useQuery } from '@tanstack/react-query';
import { storyKeys } from '../queryKeys';
import { getVoicePresets, getCustomVoices } from '../actions/getVoices';
import type { Language } from '../types/enums';

export function useVoicePresets(language: Language) {
  return useQuery({
    queryKey: [...storyKeys.voices(), language],
    queryFn: () => getVoicePresets(language),
    staleTime: 5 * 60 * 1000, // 5 min — data comes from DB, rarely changes
    gcTime: 10 * 60 * 1000,
  });
}

export function useCustomVoices(familyId: string | null | undefined) {
  return useQuery({
    queryKey: storyKeys.customVoices(familyId ?? ''),
    queryFn: () => getCustomVoices(),
    enabled: !!familyId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
